import GlobalContext from '../bootstrap';
import initPropertySliders from '../property/sliders';
import initCharacterLimit from '../characterlimit';
import onPopupOpenDirectory from '../events/popup-open-directory';
import itemDetailMaps from '../maps/item-map';

class DirectoryDetailsPage extends GlobalContext {
    constructor() {
        super();

        this._registerEvents();

        this._initialiseComponents();
    }

    _registerEvents() {
        window.addEventListener( 'twc:popup:open-directory', onPopupOpenDirectory );
    }

    _initialiseComponents(): void {
        initPropertySliders();

        initCharacterLimit();

        itemDetailMaps();
    }
}

if ( !window.directoryDetailsPage ) {
    window.directoryDetailsPage = new DirectoryDetailsPage();
}
